import { REQUIRED_OBJECT_VALIDATOR, REQUIRED_TEXT_FIELD_VALIDATOR } from '@/helpers/formHelpers/validators';
import { ORG_ADMIN_ROLE, OrgAdminRoleType } from '@/const/user';
import { ASSIGN_USER_INITIAL_VALUES, ASSIGN_USER_SCHEMA } from '@/bundle/_OrgAdmin/shared/const/const';
import MasterAdminIcon from './images/MasterAdminIcon.svg?react';
import { OptionType } from '@/components/form/fields/Select/Select';
import { CreateOrganizationWithExistingUserPayloadType } from '@/api/v1/opco/users/createOrganizationWithExistingUserApi';
import { CreateOrganizationPayloadType } from '@/api/v1/opco/organizations/createOrganizationApi';
import { SUBSCRIPTION_PLAN_TYPE, SubscriptionPlanType } from '@/const/shared';
import { boolean, object } from 'yup';

export const SUBSCRIPTION_PLAN_TYPE_OPTIONS: OptionType[] = [
  { value: SUBSCRIPTION_PLAN_TYPE.STANDARD, label: 'Standard Plan' },
  { value: SUBSCRIPTION_PLAN_TYPE.ENTERPRISE, label: 'Enterprise Plan' },
];

export const ORGANIZATION_USER_ROLE_OPTIONS = [
  { value: ORG_ADMIN_ROLE.MASTER_ADMIN, label: 'Master Admin', icon: <MasterAdminIcon /> },
];

export const CREATE_ORGANIZATION_INITIAL_VALUE = {
  organization: {
    name: '',
    subscription_plan_type: SUBSCRIPTION_PLAN_TYPE_OPTIONS[0],
    is_kyc_allowed: true,
    is_api_keys_allowed: false,
  },
  user: {
    role: ORG_ADMIN_ROLE.MASTER_ADMIN,
    ...ASSIGN_USER_INITIAL_VALUES,
  },
};

export const BASE_CREATE_ORGANIZATION_VALIDATION_SCHEMA = object().shape({
  organization: object().shape({
    name: REQUIRED_TEXT_FIELD_VALIDATOR,
    subscription_plan_type: REQUIRED_OBJECT_VALIDATOR,
    is_kyc_allowed: boolean(),
    is_api_keys_allowed: boolean(),
  }),
});

export const CREATE_ORGANIZATION_VALIDATION_SCHEMA = BASE_CREATE_ORGANIZATION_VALIDATION_SCHEMA.shape({
  user: ASSIGN_USER_SCHEMA,
});

export type CreateOrganizationFormValuesType = {
  organization: {
    name: string;
    subscription_plan_type: OptionType;
    is_kyc_allowed: boolean;
    is_api_keys_allowed: boolean;
  };
  user: {
    email: string;
    mobile_phone: string;
    first_name: string;
    middle_name?: string;
    last_name: string;
    role: OrgAdminRoleType;
  };
};

export const getCreateOrganizationPayload = (
  formValues: CreateOrganizationFormValuesType
): CreateOrganizationPayloadType => {
  return {
    ...formValues,
    organization: {
      ...formValues.organization,
      subscription_plan_type: formValues.organization.subscription_plan_type.value as SubscriptionPlanType,
    },
  };
};

export const getCreateOrganizationWithExistingUserPayload = (
  formValues: CreateOrganizationFormValuesType,
  assignedUserId: string
): CreateOrganizationWithExistingUserPayloadType => {
  return {
    organization: {
      ...formValues.organization,
      subscription_plan_type: formValues.organization.subscription_plan_type.value as SubscriptionPlanType,
    },
    user_id: assignedUserId,
  };
};
